module.exports = __webpack_public_path__ + "img/powered.449bdac0.svg";